Widgets.Rate = Class.create(Widgets.Base, {
  name: 'rate',
  defaults: {
    type: 'percentage',
    grading: '',
    size: 'normal',
    width: null
  },
  css: `
        body .widget.rate { position: relative; }

        body .widget.rate .value {
            font-size: 2em;
            padding: 6px;
            text-align: center;
        }

        body .widget.rate .indicator {
            background: #e6e6e6;
            border-radius: 4px;
            min-height: 6px;
        }

        body .widget.rate .needle {
            height: 12px;
            background: var(--colors-named-accent);
            border-radius: 4px;
            width: var(--percentage);
        }

        body .widget.rate[data-grading="green"] .needle {
            background: var(--colors-green);
        }

        body .widget.rate[data-grading="orange"] .needle {
            background: var(--colors-orange);
        }

        body .widget.rate[data-grading="red"] .needle {
            background: var(--colors-red-darker);
        }

        body .widget.rate h3 {
            text-align: center;
            padding: 8px;
            font-size: 0.9em;
        }

        /* Small size - horizontal layout */
        body .widget.rate[data-size="small"] .header {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            padding: 0 0 4px 0;
        }

        body .widget.rate[data-size="small"] h3 {
            text-align: left;
            padding: 0;
            font-size: 0.75em;
            color: #666;
        }

        body .widget.rate[data-size="small"] .value {
            font-size: 0.85em;
            font-weight: 600;
            padding: 0;
            text-align: right;
        }

        body .widget.rate[data-size="small"] .needle {
            height: 6px;
        }

        body .widget.rate[data-size="small"] {
            margin-bottom: 16px;
        }

    `,
  initWidget: function () {
    this.dataset.grading = this.options.grading;
    this.dataset.type = this.options.type;
    this.dataset.size = this.options.size;
    if (this.options.width) {
      this.internal.container.style.width = this.options.width;
    }
    if (this.options.size === 'small') {
      /* Small size: horizontal layout with header containing title and value */
      let header = new Element('div');
      header.classList.add('header');
      this.insert(header);
      if (this.options.title) {
        this.title = new Element('h3').update(this.options.title);
        header.insert(this.title);
      }
      this.value = new Element('div');
      this.value.classList.add('value');
      this.value.textContent = this.formatValue(this.options.value);
      header.insert(this.value);
      this.indicator = new Element('div');
      this.indicator.classList.add('indicator');
      this.insert(this.indicator);
      if (this.options.type == 'percentage') {
        this.indicator.style.setProperty('--percentage', (this.options.value > 2 ? this.options.value : 0) + '%');
        this.indicator.innerHTML = `<div class='needle'></div>`;
      }
    } else {
      /* Normal size: vertical layout */
      this.value = new Element('div');
      this.value.classList.add('value');
      this.value.textContent = this.formatValue(this.options.value);
      this.insert(this.value);
      this.indicator = new Element('div');
      this.indicator.classList.add('indicator');
      this.insert(this.indicator);
      if (this.options.type == 'percentage') {
        this.indicator.style.setProperty('--percentage', (this.options.value > 2 ? this.options.value : 0) + '%');
        this.indicator.innerHTML = `<div class='needle'></div>`;
      }
      if (this.options.title) {
        this.title = new Element('h3').update(this.options.title);
        this.insert(this.title);
      }
    }
  },
  formatValue: function (value) {
    if (this.options.type == 'percentage') {
      return Formatter.percentage(value);
    } else if (this.options.type == 'currency') {
      return Formatter.currency(value);
    }
    return value;
  },
  update: function (value) {
    this.options.value = value;
    this.value.textContent = this.formatValue(value);
    if (this.options.type == 'percentage') {
      this.indicator.style.setProperty('--percentage', (value > 2 ? value : 0) + '%');
    }
  }
});
//# sourceMappingURL=rate.js.map
